var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable jsdoc/require-param */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable valid-jsdoc */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/**
 * AccumulationChart base file
 */
import { Property, ChildProperty, Complex, createElement, Browser } from '@syncfusion/ej2-base';
import { isNullOrUndefined, getValue } from '@syncfusion/ej2-base';
import { DataManager } from '@syncfusion/ej2-data';
import { Border, Font, Animation, EmptyPointSettings, Connector } from '../../common/model/base';
import { Rect, PathOption } from '@syncfusion/ej2-svg-base';
import { stringToNumber, appendChildElement } from '../../common/utils/helper';
import { seriesRender, pointRender } from '../../common/model/constants';
import { getSeriesColor } from '../../common/model/theme';
import { getElement, firstToLowerCase } from '../../common/utils/helper';
/**
 * Annotation for accumulation series
 */
export class AccumulationAnnotationSettings extends ChildProperty {
}
__decorate([
    Property(null)
], AccumulationAnnotationSettings.prototype, "content", void 0);
__decorate([
    Property('0')
], AccumulationAnnotationSettings.prototype, "x", void 0);
__decorate([
    Property('0')
], AccumulationAnnotationSettings.prototype, "y", void 0);
__decorate([
    Property('Pixel')
], AccumulationAnnotationSettings.prototype, "coordinateUnits", void 0);
__decorate([
    Property('Chart')
], AccumulationAnnotationSettings.prototype, "region", void 0);
__decorate([
    Property('Middle')
], AccumulationAnnotationSettings.prototype, "verticalAlignment", void 0);
__decorate([
    Property('Center')
], AccumulationAnnotationSettings.prototype, "horizontalAlignment", void 0);
__decorate([
    Property(null)
], AccumulationAnnotationSettings.prototype, "description", void 0);
/**
 * Configures the dataLabel in accumulation chart.
 */
export class AccumulationDataLabelSettings extends ChildProperty {
}
__decorate([
    Property(false)
], AccumulationDataLabelSettings.prototype, "visible", void 0);
__decorate([
    Property(true)
], AccumulationDataLabelSettings.prototype, "showZero", void 0);
__decorate([
    Property(null)
], AccumulationDataLabelSettings.prototype, "name", void 0);
__decorate([
    Property('transparent')
], AccumulationDataLabelSettings.prototype, "fill", void 0);
__decorate([
    Property('Inside')
], AccumulationDataLabelSettings.prototype, "position", void 0);
__decorate([
    Property(5)
], AccumulationDataLabelSettings.prototype, "rx", void 0);
__decorate([
    Property(5)
], AccumulationDataLabelSettings.prototype, "ry", void 0);
__decorate([
    Property(0)
], AccumulationDataLabelSettings.prototype, "angle", void 0);
__decorate([
    Property(false)
], AccumulationDataLabelSettings.prototype, "enableRotation", void 0);
__decorate([
    Complex({ width: null, color: null }, Border)
], AccumulationDataLabelSettings.prototype, "border", void 0);
__decorate([
    Complex({ size: '11px', color: '', fontStyle: 'Normal', fontWeight: 'Normal', fontFamily: 'Segoe UI' }, Font)
], AccumulationDataLabelSettings.prototype, "font", void 0);
__decorate([
    Complex({}, Connector)
], AccumulationDataLabelSettings.prototype, "connectorStyle", void 0);
__decorate([
    Property(null)
], AccumulationDataLabelSettings.prototype, "template", void 0);
__decorate([
    Property('')
], AccumulationDataLabelSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], AccumulationDataLabelSettings.prototype, "maxWidth", void 0);
__decorate([
    Property('Ellipsis')
], AccumulationDataLabelSettings.prototype, "textOverflow", void 0);
__decorate([
    Property('Normal')
], AccumulationDataLabelSettings.prototype, "textWrap", void 0);
/**
 * Center value of the Pie series.
 */
export class PieCenter extends ChildProperty {
}
__decorate([
    Property('50%')
], PieCenter.prototype, "x", void 0);
__decorate([
    Property('50%')
], PieCenter.prototype, "y", void 0);
/**
 * Points model for the series.
 *
 * @public
 */
export class AccPoints {
    constructor() {
        /** accumulation point visibility. */
        this.visible = true;
        /** accumulation point symbol location. */
        this.symbolLocation = null;
        /** @private */
        this.region = null;
        /** @private */
        this.labelRegion = null;
        /** @private */
        this.labelVisible = true;
        this.regions = null;
        /** @private */
        this.isExplode = false;
        /** @private */
        this.isClubbed = false;
        /** @private */
        this.isSliced = false;
        /** @private  */
        this.argsData = null;
        /** @private */
        this.isLabelUpdated = null;
        /** @private */
        this.initialLabelRegion = null;
    }
}
/**
 *  Configures the series in accumulation chart.
 */
export class AccumulationSeries extends ChildProperty {
    constructor() {
        /**
         * Specifies the dataSource for the series. It can be an array of JSON objects or an instance of DataManager.
         * ```html
         * <div id='Pie'></div>
         * ```
         * ```typescript
         * let dataManager: DataManager = new DataManager({
         *         url: 'http://mvc.syncfusion.com/Services/Northwnd.svc/Tasks/'
         * });
         * let query: Query = new Query().take(50).where('Estimate', 'greaterThan', 0, false);
         * let pie: AccumulationChart = new AccumulationChart({
         * ...
         *     series: [{
         *        dataSource: dataManager,
         *        xName: 'Id',
         *        yName: 'Estimate',
         *        query: query
         *    }],
         * ...
         * });
         * pie.appendTo('#Pie');
         * ```
         *
         * @default ''
         */
        super(...arguments);
        /** @private */
        this.points = [];
        /** @private */
        this.clubbedPoints = [];
        /** @private */
        this.sumOfPoints = 0;
        /** @private */
        this.isRectSeries = true;
        /** @private */
        this.clipRect = new Rect(0, 0, 0, 0);
        /** @private */
        this.category = 'Series';
        /** @private */
        this.rightSidePoints = [];
        /** @private */
        this.leftSidePoints = [];
    }
    /**
     * To refresh the Datamanager for series
     *
     * @private
     */
    refreshDataManager(accumulation, render) {
        this.radius = this.radius ? this.radius : (Browser.isDevice && this.dataLabel.position === 'Outside') ? '40%' : '80%';
        const dateSource = this.dataSource || accumulation.dataSource;
        if (!(dateSource instanceof DataManager) && isNullOrUndefined(this.query)) {
            this.dataManagerSuccess({ result: dateSource, count: dateSource.length }, accumulation, render);
            return;
        }
        const dataManager = this.dataModule.getData(this.dataModule.generateQuery().requiresCount());
        dataManager.then((e) => this.dataManagerSuccess(e, accumulation));
    }
    /**
     * To get points on dataManager is success
     *
     * @private
     */
    dataManagerSuccess(e, accumulation, render = true) {
        const argsData = {
            name: seriesRender, series: this, data: e.result
        };
        accumulation.allowServerDataBinding = false;
        accumulation.trigger(seriesRender, argsData);
        this.resultData = e.result !== '' ? e.result : [];
        if (!accumulation.isBlazor && !render) {
            this.getPoints(this.resultData, accumulation); // To update datasource using onPropertyChanged method. incident id: 290690
        }
        /* eslint-disable */
        if ((++accumulation.seriesCounts === accumulation.visibleSeries.length && render)
            // tslint:disable-next-line:no-string-literal
            || (window['Blazor'] && !render && accumulation.seriesCounts === 1)) {
            this.getPoints(this.resultData, accumulation);
            accumulation.refreshChart();
        }
    }
    /** @private To find points from result data */
    getPoints(result, accumulation) {
        let length = Object.keys(result).length;
        this.sumOfPoints = 0;
        if (length === 0) {
            // fix for Pie datalabels are not removed for empty datasource
            this.points = [];
            return null;
        }
        this.findSumOfPoints(result);
        this.points = [];
        this.clubbedPoints = [];
        this.sumOfClub = 0;
        let point;
        let colors = this.palettes.length ? this.palettes : getSeriesColor(accumulation.theme);
        let clubValue = stringToNumber(this.groupTo, this.sumOfPoints);
        for (let i = 0; i < length; i++) {
            point = this.setPoints(result, i, colors, accumulation);
            let currentY = point.y;
            if (!this.isClub(point, clubValue, i)) {
                if (isNullOrUndefined(point.y)) {
                    point.visible = false;
                }
                this.pushPoints(point, colors);
            }
            else {
                point.index = this.clubbedPoints.length;
                point.isExplode = true;
                this.clubbedPoints.push(point);
                point.isSliced = true;
            }
        }
        this.lastGroupTo = this.groupTo;
        if (this.sumOfClub > 0) {
            let clubPoint = this.generateClubPoint();
            this.pushPoints(clubPoint, colors);
            let pointsLength = this.points.length - 1;
            this.clubbedPoints.map((point) => {
                point.index += pointsLength;
                point.color = clubPoint.color;
            });
        }
        if (this.clubbedPoints.length && this.explode && this.type === 'Pie'
            && (this.explodeAll || this.points[this.points.length - 1].index === this.explodeIndex)) {
            this.points.splice(this.points.length - 1, 1);
            this.points = this.points.concat(this.clubbedPoints);
        }
    }
    generateClubPoint() {
        let clubPoint = new AccPoints();
        clubPoint.isClubbed = true;
        clubPoint.x = 'Others';
        clubPoint.y = this.sumOfClub;
        clubPoint.text = clubPoint.originalText = clubPoint.x + ': ' + this.sumOfClub;
        clubPoint.sliceRadius = '80%';
        return clubPoint;
    }
    /**
     * Method to set point index and color
     */
    pushPoints(point, colors) {
        point.index = this.points.length;
        point.isExplode = this.explodeAll || (point.index === this.explodeIndex);
        point.color = point.color || colors[point.index % colors.length];
        this.points.push(point);
    }
    /**
     * Method to find club point
     */
    isClub(point, clubValue, index) {
        if (!isNullOrUndefined(clubValue)) {
            if (this.groupMode === 'Value' && Math.abs(point.y) <= clubValue) {
                this.sumOfClub += Math.abs(point.y);
                return true;
            }
            else if (this.groupMode === 'Point' && index >= clubValue) {
                this.sumOfClub += Math.abs(point.y);
                return true;
            }
        }
        return false;
    }
    /**
     * Method to find sum of points in the series
     */
    findSumOfPoints(result) {
        let length = Object.keys(result).length;
        for (let i = 0; i < length; i++) {
            if (!isNullOrUndefined(result[i]) && !isNullOrUndefined(result[i][this.yName]) && !isNaN(result[i][this.yName])) {
                this.sumOfPoints += Math.abs(result[i][this.yName]);
            }
        }
    }
    /**
     * Method to set points x, y and text from data source
     */
    setPoints(data, i, colors, accumulation) {
        let point = new AccPoints();
        point.x = getValue(this.xName, data[i]);
        point.y = getValue(this.yName, data[i]);
        point.percentage = (+(point.y / this.sumOfPoints * 100).toFixed(2));
        point.legendImageUrl = getValue(this.legendImageUrl, data[i]);
        point.color = getValue(this.pointColorMapping, data[i]);
        point.text = point.originalText = getValue(this.dataLabel.name || '', data[i]);
        point.tooltip = getValue(this.tooltipMappingName || '', data[i]);
        point.sliceRadius = getValue(this.radius, data[i]);
        point.sliceRadius = isNullOrUndefined(point.sliceRadius) ? '80%' : point.sliceRadius;
        point.separatorY = accumulation.intl.formatNumber(point.y, { useGrouping: accumulation.useGroupingSeparator });
        this.setAccEmptyPoint(point, i, data, colors);
        return point;
    }
    /**
     * Method render the series elements for accumulation chart
     * @private
     */
    renderSeries(accumulation, redraw) {
        let seriesGroup = redraw ? getElement(accumulation.element.id + '_Series_' + this.index) :
            accumulation.renderer.createGroup({ id: accumulation.element.id + '_Series_' + this.index });
        this.renderPoints(accumulation, seriesGroup, redraw);
        let datalabelGroup;
        if (accumulation.accumulationDataLabelModule && this.dataLabel.visible) {
            datalabelGroup = accumulation.renderer.createGroup({ id: accumulation.element.id + '_datalabel_Series_' + this.index });
            datalabelGroup.style.visibility =
                (this.animation.enable && accumulation.animateSeries && this.type === 'Pie') ? 'hidden' : 'visible';
            this.renderDataLabel(accumulation, datalabelGroup, redraw);
        }
        if (this.type === 'Pie') {
            this.findMaxBounds(this.labelBound, this.accumulationBound);
            accumulation.pieSeriesModule.animateSeries(accumulation, this.animation, this, seriesGroup);
        }
        if (accumulation.accumulationLegendModule) {
            this.labelBound.x -= accumulation.explodeDistance;
            this.labelBound.y -= accumulation.explodeDistance;
            this.labelBound.height += (accumulation.explodeDistance - this.labelBound.y);
            this.labelBound.width += (accumulation.explodeDistance - this.labelBound.x);
        }
    }
    /**
     * Method render the points elements for accumulation chart series.
     */
    renderPoints(accumulation, seriesGroup, redraw) {
        let pointId = accumulation.element.id + '_Series_' + this.index + '_Point_';
        let option;
        for (let point of this.points) {
            let argsData = {
                cancel: false, name: pointRender, series: this, point: point, fill: point.color,
                border: this.isEmpty(point) ? { width: this.emptyPointSettings.border.width, color: this.emptyPointSettings.border.color } :
                    { width: this.border.width, color: this.border.color }
            };
            accumulation.trigger(pointRender, argsData);
            point.color = argsData.fill;
            option = new PathOption(pointId + point.index, point.color, argsData.border.width || 1, argsData.border.color || point.color, this.opacity, '', '');
            accumulation[(firstToLowerCase(this.type) + 'SeriesModule')].
                renderPoint(point, this, accumulation, option, seriesGroup, redraw);
        }
        appendChildElement(false, accumulation.getSeriesElement(), seriesGroup, redraw);
    }
    /**
     * Method render the datalabel elements for accumulation chart.
     */
    renderDataLabel(accumulation, datalabelGroup, redraw) {
        accumulation.accumulationDataLabelModule.findAreaRect();
        let element = createElement('div', {
            id: accumulation.element.id + '_Series_0' + '_DataLabelCollections'
        });
        this.leftSidePoints = [], this.rightSidePoints = [];
        let firstQuarter = [];
        let secondQuarter = [];
        for (let point of this.points) {
            if (point.visible) {
                if (this.dataLabel.showZero || (!this.dataLabel.showZero && ((point.y !== 0) || (point.y === 0 &&
                    this.emptyPointSettings.mode === 'Zero')))) {
                    accumulation.accumulationDataLabelModule.renderDataLabel(point, this.dataLabel, datalabelGroup, this.points, this.index, element, redraw);
                }
            }
            if (point.midAngle >= 90 && point.midAngle <= 270) {
                this.leftSidePoints.push(point);
            }
            else {
                if (point.midAngle >= 0 && point.midAngle <= 90) {
                    secondQuarter.push(point);
                }
                else {
                    firstQuarter.push(point);
                }
            }
        }
        firstQuarter.sort((a, b) => a.midAngle - b.midAngle);
        secondQuarter.sort((a, b) => a.midAngle - b.midAngle);
        this.leftSidePoints.sort((a, b) => a.midAngle - b.midAngle);
        this.rightSidePoints = firstQuarter.concat(secondQuarter);
        accumulation.accumulationDataLabelModule.drawDataLabels(this, this.dataLabel, datalabelGroup, element, redraw);
        if (this.dataLabel.template !== null && element.childElementCount) {
            let dataLabelCallBack = accumulation.accumulationDataLabelModule.drawDataLabels.bind(accumulation.accumulationDataLabelModule, this, this.dataLabel, datalabelGroup, element, redraw);
            // tslint:disable-next-line:no-any
            if (accumulation.isReact) {
                accumulation.renderReactTemplates(dataLabelCallBack);
            }
            appendChildElement(false, getElement(accumulation.element.id + '_Secondary_Element'), element, redraw);
        }
        appendChildElement(false, accumulation.getSeriesElement(), datalabelGroup, redraw);
    }
    /**
     * To find maximum bounds for smart legend placing
     *
     * @private
     */
    findMaxBounds(totalbound, bound) {
        totalbound.x = bound.x < totalbound.x ? bound.x : totalbound.x;
        totalbound.y = bound.y < totalbound.y ? bound.y : totalbound.y;
        totalbound.height = (bound.y + bound.height) > totalbound.height ? (bound.y + bound.height) : totalbound.height;
        totalbound.width = (bound.x + bound.width) > totalbound.width ? (bound.x + bound.width) : totalbound.width;
    }
    /**
     * To set empty point value for null points
     * @private
     */
    setAccEmptyPoint(point, i, data, colors) {
        if (!(isNullOrUndefined(point.y) || isNaN(point.y))) {
            return null;
        }
        point.color = this.emptyPointSettings.fill || point.color;
        switch (this.emptyPointSettings.mode) {
            case 'Zero':
                point.y = 0;
                point.visible = true;
                break;
            case 'Average':
                let previous = data[i - 1] ? (data[i - 1][this.yName] || 0) : 0;
                let next = data[i + 1] ? (data[i + 1][this.yName] || 0) : 0;
                point.y = (Math.abs(previous) + Math.abs(next)) / 2;
                this.sumOfPoints += point.y;
                point.visible = true;
                break;
            default:
                point.visible = false;
                break;
        }
    }
    /**
     * To find point is empty
     */
    isEmpty(point) {
        return point.color === this.emptyPointSettings.fill;
    }
}
__decorate([
    Property('')
], AccumulationSeries.prototype, "dataSource", void 0);
__decorate([
    Property()
], AccumulationSeries.prototype, "query", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "xName", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "name", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "tooltipMappingName", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "yName", void 0);
__decorate([
    Property(true)
], AccumulationSeries.prototype, "visible", void 0);
__decorate([
    Complex({ color: null, width: 0 }, Border)
], AccumulationSeries.prototype, "border", void 0);
__decorate([
    Complex(null, Animation)
], AccumulationSeries.prototype, "animation", void 0);
__decorate([
    Property('SeriesType')
], AccumulationSeries.prototype, "legendShape", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "legendImageUrl", void 0);
__decorate([
    Property('')
], AccumulationSeries.prototype, "pointColorMapping", void 0);
__decorate([
    Property(null)
], AccumulationSeries.prototype, "selectionStyle", void 0);
__decorate([
    Property(null)
], AccumulationSeries.prototype, "groupTo", void 0);
__decorate([
    Property('Value')
], AccumulationSeries.prototype, "groupMode", void 0);
__decorate([
    Complex({}, AccumulationDataLabelSettings)
], AccumulationSeries.prototype, "dataLabel", void 0);
__decorate([
    Property([])
], AccumulationSeries.prototype, "palettes", void 0);
__decorate([
    Property(0)
], AccumulationSeries.prototype, "startAngle", void 0);
__decorate([
    Property(null)
], AccumulationSeries.prototype, "endAngle", void 0);
__decorate([
    Property(null)
], AccumulationSeries.prototype, "radius", void 0);
__decorate([
    Property('0')
], AccumulationSeries.prototype, "innerRadius", void 0);
__decorate([
    Property('Pie')
], AccumulationSeries.prototype, "type", void 0);
__decorate([
    Property(true)
], AccumulationSeries.prototype, "enableTooltip", void 0);
__decorate([
    Property(false)
], AccumulationSeries.prototype, "explode", void 0);
__decorate([
    Property('30%')
], AccumulationSeries.prototype, "explodeOffset", void 0);
__decorate([
    Property(false)
], AccumulationSeries.prototype, "explodeAll", void 0);
__decorate([
    Property(null)
], AccumulationSeries.prototype, "explodeIndex", void 0);
__decorate([
    Complex({ mode: 'Drop' }, EmptyPointSettings)
], AccumulationSeries.prototype, "emptyPointSettings", void 0);
__decorate([
    Property(0)
], AccumulationSeries.prototype, "gapRatio", void 0);
__decorate([
    Property('80%')
], AccumulationSeries.prototype, "width", void 0);
__decorate([
    Property('80%')
], AccumulationSeries.prototype, "height", void 0);
__decorate([
    Property('20%')
], AccumulationSeries.prototype, "neckWidth", void 0);
__decorate([
    Property('20%')
], AccumulationSeries.prototype, "neckHeight", void 0);
__decorate([
    Property('Linear')
], AccumulationSeries.prototype, "pyramidMode", void 0);
__decorate([
    Property(1)
], AccumulationSeries.prototype, "opacity", void 0);
/**
 * method to get series from index
 * @private
 */
export function getSeriesFromIndex(index, visibleSeries) {
    for (let series of visibleSeries) {
        if (index === series.index) {
            return series;
        }
    }
    return visibleSeries[0];
}
/**
 * method to get point from index
 * @private
 */
export function pointByIndex(index, points) {
    for (let point of points) {
        if (point.index === index) {
            return point;
        }
    }
    return null;
}
